import {
    FETCH_ACCESS_POINTS_ACCESS_METHODS,
    FETCH_ACCESS_POINTS_ACCESS_METHODS_FAILURE,
    FETCH_ACCESS_POINTS_ACCESS_METHODS_SUCCESS,
} from 'store/actions/types';

export const fetchAccessPointAccessMethods = (payload) => {
    return {
        type: FETCH_ACCESS_POINTS_ACCESS_METHODS,
        payload: payload,
    };
};

export const fetchAccessPointAccessMethodsFailure = (error) => {
    return {
        type: FETCH_ACCESS_POINTS_ACCESS_METHODS_FAILURE,
        error: error,
    };
};

export const fetchAccessPointAccessMethodsSuccess = (response) => {
    return {
        type: FETCH_ACCESS_POINTS_ACCESS_METHODS_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/accessPoints/access-methods/fetch/fetchAccessPointAccessMethods.js